import { render, staticRenderFns } from "./CarisSelection.vue?vue&type=template&id=79c298a0&scoped=true"
import script from "./CarisSelection.vue?vue&type=script&lang=js"
export * from "./CarisSelection.vue?vue&type=script&lang=js"
import style0 from "./CarisSelection.vue?vue&type=style&index=0&id=79c298a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c298a0",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fcaris-selection%2FCarisSelection.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports